<template>
  <v-hover v-slot="{ hover }">
    <v-card
      width="100%"
      flat
      color="accent"
      :style="{opacity: disabled ? .37 : 1}"
      @click="$emit('click', $event)"
    >
      <v-card-text class="px-0 text-center">
        <v-icon
          :color="hover ? 'primary' : 'white'"
          size="48"
          v-text="icon"
        />
        <div class="mt-2 text-no-wrap" v-text="label" />
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
  export default {
    props: {
      icon: {
        required: true,
        type: String,
      },
      label: {
        required: true,
        type: String,
      },
      disabled: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
